export default __webpack_public_path__ + "static/media/kitchen4-afterD-1920w.a6aa7a29.png";